import React, { useState, useEffect } from 'react';
import './policy.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
const Policy = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('privacy');
  const params = new URLSearchParams(location.search);
  const isFromEmail = params.get('source') === 'email';
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get("section");
    if (section) {
      setActiveSection(section);
    }
  }, [location]);

  const renderContent = () => {
    if (activeSection === 'privacy') {
      return (
        <>
          <p>Effective Date: 05 Feb 2025
          </p>
          <p>At Signite Technology Pvt Ltd, we respect your privacy and are committed
            to protecting the personal information you share with us. This Privacy Policy
            outlines how we collect, use, disclose, and protect your information when you use our Software-as-a-Service (SaaS) based web platform (“Service”).
            By accessing or using our Service, you agree to the terms outlined in
            this Privacy Policy.</p>

          <p>This policy complies with applicable data protection laws,
            including the  <span style={{ fontWeight: 'bold' }}>
              Information Technology (Reasonable Security Practices and Procedures and Sensitive
              Personal Data or Information) Rules, 2011
            </span>, and other relevant provisions under Indian privacy
            laws.</p>

          <h2>1. Information We Collect</h2>
          <p>
            We may collect the following types of personal and non-personal information from users of our platform:
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Personal Information : </strong><span className="policy-list"> Information that can identify you, including, but not limited to : </span>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">Name</li>
                <li className="policy-list">Email address</li>
                <li className="policy-list">Phone number</li>
                <li className="policy-list">Company name</li>
                <li className="policy-list">Payment details</li>
                <li className="policy-list">Address</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Non-personal Information : </strong><span className="policy-list"> This includes aggregated, anonymized, or non-identifiable information, such as:</span>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">Usage data (pages visited, time spent on platform, etc.)</li>
                <li className="policy-list">Device information (browser type, operating system, IP address)</li>
                <li className="policy-list">Cookies and tracking technologies</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Account Data : </strong><span className="policy-list"> Any data you input into the platform while using the Service, including user-generated content, reports, and documents uploaded.</span>
            </li>
          </ul>
          <br />
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect for various purposes, including :
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">To Provide and Improve Our Services : </strong>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">To deliver, operate, and maintain our Service.</li>
                <li className="policy-list">To enhance and personalize user experience by analyzing usage patterns.</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Customer Support : </strong>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">To respond to your queries, requests, or technical issues.</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Billing and Payments : </strong>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">To process and manage billing and payments for your subscription to the Service.</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Marketing and Communications : </strong>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">To send you newsletters, promotional materials, or updates related to the Service, if you have opted in.</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Compliance and Legal Obligations : </strong>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">To comply with legal obligations, resolve disputes, enforce agreements, and protect our rights and interests.</li>
              </ul>
            </li>
          </ul>
          <br />
          <h2>3. How We Protect Your Information</h2>
          <p>We implement reasonable technical and organizational measures to protect your data from unauthorized access, disclosure,
            alteration, or destruction. These measures include : </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Encryption : </strong><span className="policy-list"> We use encryption technologies to safeguard sensitive data during transmission.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Access Controls : </strong><span className="policy-list"> We restrict access to personal data to authorized personnel only.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Regular Audits : </strong><span className="policy-list"> We perform security audits and maintain industry-standard practices to ensure the integrity and security of your data.</span>
            </li>
          </ul>
          <br />
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies, web beacons, and other tracking technologies to
            collect information about how users interact with our platform.
            Cookies help us personalize your experience, analyze site usage,
            and provide you with relevant advertisements. You can manage your cookie preferences through your browser settings.
          </p>

          <h2>5. Sharing and Disclosure of Information</h2>
          <p>We may share your personal information in the following circumstances:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Service Providers : </strong><span className="policy-list"> We may share information with trusted third-party service providers who assist us with hosting, data storage, payment processing, customer support, and marketing efforts. These providers are contractually obligated to maintain the confidentiality and security of your information.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Legal Compliance : </strong><span className="policy-list"> We may disclose your information if required by law or if we believe such action is necessary to:</span>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">Comply with a legal obligation or judicial process</li>
                <li className="policy-list">Protect the rights, property, or safety of Signite Technology Pvt Ltd, its customers, or others</li>
                <li className="policy-list">Investigate or prevent illegal activities</li>
              </ul>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Business Transfers : </strong><span className="policy-list"> If Signite Technology Pvt Ltd is involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction, subject to the privacy policy in effect at the time.</span>
            </li>
          </ul>
          <br />
          <h2>6. Your Rights and Choices</h2>
          <p>As a user, you have the following rights regarding your personal information:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Access : </strong><span className="policy-list"> You can request access to your personal data and obtain a copy of the data we hold.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Correction : </strong><span className="policy-list"> You may update or correct any inaccuracies in the information you have provided.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Deletion : </strong><span className="policy-list"> You can request the deletion of your personal data subject to applicable laws and contractual obligations.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Opt-out of Marketing Communications : </strong><span className="policy-list"> You may opt out of receiving marketing communications at any time by clicking the “unsubscribe” link in the email or contacting us directly.</span>
            </li>
          </ul>
          <p>
            To exercise your rights or for any questions regarding your information, please contact us at{' '}
            <a
              href="mailto:admin@leaderly.in"
              className="policy-contact-link"
            >
              admin@leaderly.in
            </a>
            {' '}or through our customer support page.
          </p>
          <br />

          <h2>7. Data Retention</h2>
          <p>We retain your personal data for as long as necessary to fulfill the purposes outlined in this Privacy Policy, to comply with legal obligations,
            resolve disputes, and enforce our agreements. Once your information is no longer needed,
            we will take steps to securely delete or anonymize the data.</p>

          <h2>8. Third-Party Links</h2>
          <p>Our platform may contain links to third-party websites or services that are not operated by us. We are not responsible for the privacy practices or content of those third parties.
            We encourage you to review the privacy policies of any third-party sites you visit.</p>

          <h2>9. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time to reflect changes in our practices, legal obligations, or industry standards. When we make changes, we will update the "Effective Date" at the top of this policy
            and notify you through the platform or via email, as appropriate.</p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions or concerns regarding this Privacy Policy or how we handle your personal information,
            please contact us at{' '}
            <a
              href="mailto:admin@leaderly.in"
              className="policy-contact-link"
            >
              admin@leaderly.in
            </a>
          </p>

          <hr />

          <p>This Privacy Policy applies solely to the information collected
            through our SaaS web platform and does not apply to any other information collected offline or through
            third-party websites or services.
          </p>
        </>
      );
    } else if (activeSection === 'terms') {
      return (
        <>
          <p>Effective Date: 5 Feb 2025</p>
          <p>Welcome to Signite Technology Pvt Ltd (“we,” “us,” “our”). These Terms of Service (“Terms”) govern your access to and use of our Software-as-a-Service (SaaS) web platform (“Service”), which is provided by Signite Technology Pvt Ltd, a company registered under the laws of India. By accessing or using our Service,
            you agree to be bound by these Terms. If you do not agree to these Terms, you must not use the Service.</p>
          <p>Please read these Terms carefully before using the Service.</p>

          <hr />

          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Service, you agree to comply with and
            be bound by these Terms. If you are using the Service on behalf of a company or other legal entity, you represent and warrant that you have the authority to bind that entity to these Terms.
          </p>
          <p>These Terms form a legally binding agreement between you and Signite Technology Pvt Ltd. We may update these Terms from time to time, and any changes will be effective once posted
            on our website or notified to you via email.</p>

          <hr />

          <h2>2. Use of the Service</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Eligibility : </strong><span className="policy-list"> To use the Service, you must be at least 18 years old and capable of forming legally binding contracts under applicable law.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Account Creation : </strong><span className="policy-list"> You must create an account to access and use the Service. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">License Grant : </strong><span className="policy-list"> We grant you a limited, non-exclusive, non-transferable license to access and use the Service solely for its intended purpose, subject to these Terms.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Restrictions : </strong><span className="policy-list"> You agree not to : </span>
              <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="policy-list">Use the Service in any unlawful manner or for any unlawful purpose.</li>
                <li className="policy-list">Interfere with or disrupt the integrity or performance of the Service.</li>
                <li className="policy-list">Reverse engineer, decompile, or disassemble the Service or attempt to gain unauthorized access to the Service or its related systems.</li>
              </ul>
            </li>
          </ul>

          <hr />

          <h2>3. Subscription and Payment</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Subscription Plans : </strong><span className="policy-list"> The Service may be provided under different subscription plans, as outlined on our website. By subscribing to a plan, you agree to pay the fees associated with that plan.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Billing and Payment : </strong><span className="policy-list"> You agree to provide accurate billing information and promptly pay any fees associated with your use of the Service. Subscription fees are generally billed on a monthly/annual basis, and payment is due at the start of each billing cycle.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Taxes : </strong><span className="policy-list">  All fees are exclusive of applicable taxes. You are responsible for any taxes, duties, or other governmental charges arising from your use of the Service.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Refunds and Cancellations : </strong><span className="policy-list">  Subscription fees are non-refundable, except where required by law. You may cancel your subscription at any time through your account settings, and access to the Service will continue until the end of your current billing period.</span>
            </li>
          </ul>

          <hr />

          <h2>4. Intellectual Property</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Ownership : </strong><span className="policy-list"> All intellectual property rights, including but not limited to copyrights, trademarks, and patents, in the Service and its content are owned by Signite Technology Pvt Ltd or its licensors. You acknowledge that you do not acquire any ownership rights in the Service by using it.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">User Content : </strong><span className="policy-list"> You retain ownership of any content you upload, submit, or otherwise transmit through the Service (“User Content”). However, by submitting User Content, you grant Signite Technology Pvt Ltd a worldwide, non-exclusive, royalty-free license to use, store, and display the User Content in connection with providing the Service.</span>
            </li>
          </ul>

          <hr />

          <h2>5. Privacy and Data Protection</h2>
          <p>
            Your use of the Service is governed by our <span style={{ fontWeight: 'bold' }}>Privacy Policy</span>, which explains how we collect, use, and protect your personal data. By using the Service, you agree to the collection and use of your personal data as described in the Privacy Policy.
          </p>

          <hr />

          <h2>6. Confidentiality</h2>
          <p>You agree to maintain the confidentiality of any
            information marked as confidential by Signite Technology Pvt Ltd that you receive through the Service.
            You will not disclose such information to any third party unless required by law or with prior written consent from Signite Technology Pvt Ltd.
          </p>

          <hr />

          <h2>7. Limitation of Liability</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">No Warranties : </strong><span className="policy-list"> The Service is provided "as is" and "as available," without any warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Limitation of Liability : </strong><span className="policy-list"> To the fullest extent permitted by law, Signite Technology Pvt Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Service, including but not limited to loss of profits, data, or business opportunities.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Maximum Liability : </strong><span className="policy-list">  In no event shall Signite Technology Pvt Ltd’s total liability exceed the amount you paid for the Service during the 12 months immediately preceding the event giving rise to the claim.</span>
            </li>
          </ul>

          <hr />

          <h2>8. Indemnification</h2>
          <p>You agree to indemnify and hold harmless Signite Technology Pvt Ltd, its affiliates, officers, directors, employees, and agents from any claims, damages, liabilities, and expenses (including reasonable attorneys' fees) arising out of or related to:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <span className="policy-list"> Your use of the Service in violation of these Terms.</span>
            </li>
            <li>
              <span className="policy-list"> Your violation of any law or the rights of a third party.</span>
            </li>
          </ul>

          <hr />

          <h2>9. Termination and Suspension</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Termination by You : </strong><span className="policy-list"> You may terminate your account at any time by contacting customer support or through your account settings.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Termination by Us : </strong><span className="policy-list"> We may suspend or terminate your access to the Service at our discretion if you violate these Terms, fail to pay fees, or engage in conduct that threatens the security, integrity, or availability of the Service.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Effect of Termination : </strong><span className="policy-list"> Upon termination, you will cease all use of the Service and delete all copies of the Service from your devices. Any outstanding fees owed will remain due.</span>
            </li>
          </ul>

          <hr />

          <h2>10. Governing Law and Dispute Resolution</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Governing Law : </strong><span className="policy-list"> These Terms are governed by and construed in accordance with the Laws of India.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Dispute Resolution : </strong><span className="policy-list"> Any disputes arising out of or related to these Terms or the Service shall be resolved through binding arbitration in accordance with the Arbitration and Conciliation Act, 1996. The arbitration shall be conducted in Bangalore, India, in the English language.</span>
            </li>
          </ul>

          <hr />

          <h2>11. Miscellaneous</h2>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>
              <strong className="policy-side-heading">Force Majeure : </strong><span className="policy-list"> Signite Technology Pvt Ltd shall not be liable for any failure or delay in performance under these Terms caused by events beyond our reasonable control, such as natural disasters, acts of government, or technical failures.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Entire Agreement : </strong><span className="policy-list"> These Terms, along with any other legal notices and policies published by Signite Technology Pvt Ltd  on the Service, constitute the entire agreement between you and Signite Technology Pvt Ltd regarding the use of the Service.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Severability : </strong><span className="policy-list"> If any provision of these Terms is deemed unlawful, void, or unenforceable, the remaining provisions shall remain in full force and effect.</span>
            </li>
            <br />
            <li>
              <strong className="policy-side-heading">Assignment : </strong><span className="policy-list"> You may not assign or transfer any of your rights or obligations under these Terms without prior written consent from Signite Technology Pvt Ltd.</span>
            </li>
          </ul>

          <hr />

          <h2>12. Contact Information</h2>
          <p>
            If you have any questions, concerns, or requests regarding these Terms, please contact us at{' '}
            <a
              href="mailto:admin@leaderly.in"
              className="policy-contact-link"
            >
              admin@leaderly.in
            </a>.
          </p>

          <hr />
          <p>These Terms of Service apply to all users of the Service and may be updated from time to time. By continuing to use the Service, you
            agree to be bound by any changes to these Terms.</p>
        </>
      );
    }
  };

  return (
    <div>
      <div className='fluid-container'>
        <div className="policy-heading-container">

          <div className='privacy-breadcrumb'>
            <div className="policy-breadcrumb">
              <span style={{ color: '#FFFFFF', fontWeight: '600', textDecoration: 'none', marginRight: '50px' }}>
                {isFromEmail ? (
                  <Link
                    to="/"
                    style={{ color: '#FFFFFF', textDecoration: 'none' }}
                  >
                    Back
                  </Link>
                ) : (
                  <Link
                    to={-1}
                    style={{ color: '#FFFFFF', textDecoration: 'none' }}
                    state={{ scrollPosition: location.state?.scrollPosition }}
                  >
                    Back
                  </Link>
                )}
                <span style={{ marginLeft: '10px' }}> /</span>
                <span style={{ marginLeft: '10px' }}> Policy</span>
              </span>
            </div>
          </div>
          <div className="policy-heading-container-p">
            <p className="policy-heading">Policy</p>
          </div>
        </div>
        <div className="policy-container">
          <div className="policy-sidebar">
            <button
              className={`policy-button ${activeSection === 'privacy' ? 'active' : 'inactive'}`}
              onClick={() => setActiveSection('privacy')}
            >
              Privacy Policy
            </button>
            <button
              className={`policy-button ${activeSection === 'terms' ? 'active' : 'inactive'}`}
              onClick={() => setActiveSection('terms')}
            >
              Terms & Conditions
            </button>
          </div>
          <div className="policy-content">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default Policy;